import React from "react";
import Registrations from "./Registrations";
import Downloads from "./Downloads";
import Logins from "./Logins";

const Dashboard = () => {
  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="dashboard-container">
            <Registrations />
            {/* <Downloads /> */}
            <Logins />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
